import { Positions } from '@/utils/providers/PositionsProvider';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ReadyState } from 'react-use-websocket';
import { PURGE } from 'redux-persist';
import { RootState } from '../store';

// Balances are stored as balances[currency][settlementData] = {balanceItem}
export interface NopPositionState {
    status: keyof typeof ReadyState;
    nopPositions: Positions;
}

const initialState: NopPositionState = {
    status: 'UNINSTANTIATED',
    nopPositions: {
        cryptoCfd: [],
        fx: [],
        indexCfd: [],
        futureCfd: [],
        baseCurrency: '',
        isHeartBeat: false
    }
};

export const nopPositionSlice = createSlice({
    name: 'nopPosition',
    initialState,
    reducers: {
        setNopPositionStatus: (state, action: PayloadAction<keyof typeof ReadyState>) => {
            state.status = action.payload;
        },
        setNopPositions: (state, action: PayloadAction<any>) => {
            state.nopPositions = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState);
    }
});

export const { setNopPositionStatus, setNopPositions } = nopPositionSlice.actions;
export const selectNopPositionStatus = (state: RootState) => state.nopPosition.status;
export const selectNopPositions = (state: RootState) => state.nopPosition.nopPositions;

export default nopPositionSlice.reducer;
